<template>
  <div>
    <div ref= 'dialog' class="h-dialogContainer">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{$t("Pm.resourceType")}}:</div>
            <input class="e-input" type="text" v-model="neType" disabled="disabled"/>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox-topo-trunk">
          <div class="h-inputLit">{{$t("Pm.resource_name")}}:</div>
          <input class="e-input" type="text"  v-model="neName" disabled="disabled"/>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{$t("Pm.ne_id")}}:</div>
            <input class="e-input" type="text"  v-model="neId" disabled="disabled"/>
          </div>
        </div>
      </div>

      <div class="h-pm-trunk">
        <div class="h-pm-trunka">
            <div class="h-topo-trunk-searchbox">
              <div class="h-pm-trunk-search">
                <ejs-textbox :placeholder='$t("Pm.chooseObject")' v-model="searchString" maxlength="255"/>
              </div>
              <!-- <div class='h-pm-border-bottom '></div> -->

            </div>
          <div><ejs-treeview ref='tree'  :fields='searchFields' :showCheckBox='true' :nodeChecked='nodeChecked'></ejs-treeview></div>
        </div>
        <div class="h-pm-trunkd"></div>

        <div class="h-pm-trunkb">
          <div>
            <div class='h-toolbarBg'>
            <div class='e-control e-toolbar' >
                <ejs-toolbar ref='toolbar'>
                    <e-items>
                        <e-item id='remove' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Pm.del")' :click='removeItems'></e-item>
                    </e-items>
                </ejs-toolbar>
            </div>
            </div>
            <ejs-grid ref="gridB" v-bind:dataSource="listData">
              <e-columns>
                <e-column type='checkbox' width='10%'></e-column>
                <e-column field="text" :headerText='headerText' width='85%' textAlign="left" clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
      <div class="h-clear-rowMg"></div>
    </div>
    </div>
</template>

<script>
import { CommandColumn } from '@syncfusion/ej2-vue-grids';

export default {
  name: 'editKPIChart',
  components: {},
  props: ['nodeParam', 'isEditDialogShow'],
  data() {
    return {
      listData: [],
      initTree: {},
      searchString: '',
      oldSearchString:'',
      fields: {},
      treeDataArray: [],
      treeDatas: {},
      checkedNodeData: [],
    };
  },
  watch: {
    isEditDialogShow(val) {
      this.getKpiTreeDatas();
    }
  },
  provide: {
    grid: [CommandColumn]
  },
  mounted() {
  },
  computed: {
    neId() {
      return this.nodeParam.neId;
    },
    neType() {
      return this.nodeParam.neType;
    },
    neName() {
      return this.nodeParam.neName;
    },
    searchFields() {
      const This = this;
      const treeData = This.fields;
      const searchString = This.searchString.trim().toLowerCase();
      if (!searchString) {
        if(this.oldSearchString !==''){
          this.oldSearchString = searchString;
          this.treeDatas = this.setTreeData('0');
          this.fields = {
            dataSource: this.treeDatas,
            id: 'nodeId',
            text: 'neName',
            child: 'children',
            expanded: 'neName',
            tooltip: 'neName',
            isChecked:'isChecked'
            // iconCss:'iconCls'
          };
          return this.fields;
        }
        return treeData;
      }

      this.oldSearchString = searchString;
      let selectedData = [];
      selectedData = This.treeDataArray.filter(item => ((item.neName.trim().toLowerCase().indexOf(searchString) !== -1) && item.isLeaf)).map(item => {
        const { nodeId, isLeaf, neName} = item;
        const isExist = this.checkedNodeData.filter(item=>item.nodeId === nodeId);
        const isChecked = (isExist.length) > 0 ? true : false;
        return {
          nodeId,
          isLeaf,
          neName,
          children: [],
          isChecked
        };
      });

      if (selectedData.length === 0) {
        selectedData = This.initTree;
      }

      return ({
        dataSource: selectedData,
        id: 'nodeId',
        text: 'neName',
        child: 'children',
        isLeaf: 'isLeaf',
        isChecked:'isChecked'
        // iconCss:'iconCls'
      });
    },
    headerText() {
      return `${this.$t('Pm.selectedKpiPath')}:${this.listData.length}`;
    },

  },
  methods: {
    getKpiTreeDatas() {
      this.$axios.post(`/lte/pm/kpichart/getKpiTreeDatas.html?chartTypeId=2_3&neVersion=${this.nodeParam.neVersionId}&neType=${this.nodeParam.neType}`).then((response) => {
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          if (response.data.resultVal.valueJson === null) {
            return;
          }
          this.treeDataArray = JSON.parse(response.data.resultVal.valueJson);
          for (let node of this.treeDataArray) {
            node.neName = (this._i18n.locale === 'zh') ? node.nodeNameCn : node.nodeNameEn;
            node.isLeaf = this.isLeaf(node);
          }

          this.treeDatas = this.setTreeData('0');
          this.fields = {
            dataSource: this.treeDatas,
            id: 'nodeId',
            text: 'neName',
            child: 'children',
            expanded: 'neName',
            tooltip: 'neName',
            isChecked:'isChecked'
            // iconCss:'iconCls'
          };
        } else {
          console.log('error', response.data.errorCode);
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    },
    removeItems(event) {
      let data = this.$refs.gridB.getSelectedRecords();
      if(data.length  === 0){
        return;
      }

      for (let node of data) {
        this.checkedNodeData = this.checkedNodeData.filter(item => item.nodeId !== node.nodeId);
        this.listData = this.listData.filter(item => item.nodeId !== node.nodeId);
      }

      this.treeDatas = this.setTreeData('0');
      this.fields = {
        dataSource: this.treeDatas,
        id: 'nodeId',
        text: 'neName',
        child: 'children',
        expanded: 'neName',
        tooltip: 'neName',
        isChecked:'isChecked'
        // iconCss:'iconCls'
      };

      this.$emit('getCheckedNodeData', this.checkedNodeData);
      this.$emit('getListData', this.listData);
    },

    setTreeData(parentId) {
      return this.treeDataArray
        .filter(item => item.parentId === parentId)
        .map(item => {
          const { nodeId, neName} = item;
          const isExist = this.checkedNodeData.filter(item=>item.nodeId === nodeId);
          const isChecked = (isExist.length) > 0 ? true : false;
          return {
            nodeId,
            neName,
            children: this.setTreeData(item.nodeId),
            isChecked,
          };
        });
    },
    isLeaf(node) {
      const hasChildren = this.treeDataArray.filter(item => item.parentId === node.nodeId);
      const isLeaf = !((hasChildren.length > 0));
      return isLeaf;
    },
    getNodesParentStr(nodeTem) {
      const { nodeId } = nodeTem;
      const nodeParentInfo = [];
      nodeParentInfo.push(nodeTem.neName);

      while (nodeTem.parentId !== '0') {
        const nodeArr = this.treeDataArray.filter(item => item.nodeId === nodeTem.parentId);
        nodeTem = nodeArr[0];
        if (nodeTem.parentId !== '0') {
          nodeParentInfo.push(nodeTem.neName);
        }
      }

      let str = '';
      for (let i = 0; i < nodeParentInfo.length; i++) {
        str = (i === nodeParentInfo.length - 1) ? (nodeParentInfo[i] + str) : (`/${nodeParentInfo[i]}${str}`);
      }

      const nodeStr = {
        text: str,
        nodeId
      };

      return nodeStr;
    },
    nodeChecked(event) {
      const { action,data } = event;
      if (action === 'check') {
        let realNodes = [];
        for (const node of data) {
          const isExist = this.listData.filter(item => item.nodeId === node.id);
          if ((!node.hasChildren) && (isExist.length === 0)){
            const info = this.treeDataArray.filter(item => item.nodeId === node.id);
            realNodes.push(info[0]);
          }
        }

        for (const nodeInfo of realNodes) {
          this.checkedNodeData.push(nodeInfo);
          const nodeTem = nodeInfo;
          const nodeStr = this.getNodesParentStr(nodeTem);
          this.listData.push(nodeStr);
        }

      }else if(action === 'uncheck'){
        for(let node of data){
          if(!node.hasChildren){
            this.checkedNodeData = this.checkedNodeData.filter(item=>item.nodeId !== node.id);
            this.listData = this.listData.filter(item=>item.nodeId !== node.id);
          }
        }
      }

      this.$emit('getCheckedNodeData', this.checkedNodeData);
      this.$emit('getListData', this.listData);
    },

  }
};
</script>
